import React, { useState, useEffect } from "react";
import { Grid, FormLabel, TextField } from "@material-ui/core";
import { useStyles } from "src/styles/FormTextInputStyles";
import HelpIconButton from "src/components/common/HelpIconButton";

type TextInputProps = {
    inputValue?: string,
    label: string,
    placeholder?: string,
    showError?: boolean,
    onInput: (value:string) => void
    showHelp: boolean
    helpMessage? :string
}

/**
 *  This is a re-usable Component. Provides an input text field with a label. 
 *  If the input is invalid, it will show error style and error message.
 */
const FormTextInput : React.FunctionComponent<TextInputProps>  = (props: TextInputProps) => {
    const styles = useStyles();
    const[inputText, setInputText] = useState('');

    useEffect(() => {
        if (props.inputValue) setInputText(props.inputValue);
    },[props.inputValue]);

    const handleTextChange= (event: React.ChangeEvent<any>) => {
        setInputText(event.target.value);
        props.onInput(event.target.value);
    }

    let helpIconButton;
    if (props.showHelp && props.helpMessage) {
        helpIconButton = (
            <HelpIconButton message={props.helpMessage}/>
        )
    }

    return (
        <Grid 
            container
            alignItems="center" 
            spacing={1}>
            <Grid item >
                <FormLabel className={props.showError ? `${styles.errorLabel}` : `${styles.inputLabel}`}>{props.label}</FormLabel>
            </Grid>
            <Grid item>
                <TextField
                    className={styles.inputField}
                    placeholder={props.placeholder}
                    onChange={handleTextChange}
                    value={inputText}/>
            </Grid>
            {helpIconButton}
        </Grid>
    );
}

export default FormTextInput;
